import '../styles/index.sass';

import App from './App';

window.onload = () => {
  new App();
  document.body.style.opacity = 1;
  
};